import { Dialogue, Link } from '@cognitranlimited/itis-web';
import React from 'react';
import { closeProcedureApplicabilityDialogue, selectIsProcedureApplicabilityDialogueOpen, selectProcedureApplicabilityDialogueParams } from './procedureApplicabilitySlice';
import { useProcedureApplicabilityContext } from './procedureApplicabilityContext';
import { useProcedureApplicabilitySelector } from './procedureApplicabilityStore';
import './procedureApplicabilityDialogue.scss';
export var ProcedureApplicabilityDialogue = function () {
    var _a = useProcedureApplicabilityContext(), strings = _a.strings, dispatch = _a.dispatch, navigation = _a.navigation;
    var isOpen = useProcedureApplicabilitySelector(selectIsProcedureApplicabilityDialogueOpen);
    var params = useProcedureApplicabilitySelector(selectProcedureApplicabilityDialogueParams);
    if (!params) {
        return null;
    }
    function closeDialogue() {
        dispatch(closeProcedureApplicabilityDialogue());
    }
    return React.createElement(Dialogue, { className: "ProcedureApplicabilityDialogue", isOpen: isOpen, onClose: closeDialogue },
        React.createElement(Dialogue.Header, { title: params.title, onClose: closeDialogue }),
        React.createElement(Dialogue.Content, null,
            strings.procedureApplicability.selectOption(params.items.length, params.title),
            React.createElement("ul", null, params.items.map(function (item) { return React.createElement("li", { key: item.title },
                React.createElement(Link, { href: navigation.document(params.document, { fragment: "".concat(item.procedureReference, "!!1!") }), onClick: closeDialogue }, item.title)); }))));
};
